import React from 'react';
import {motion} from 'framer-motion';
import {useLocation} from 'react-router-dom';

// This will be the global wrapper for page transitions
const PageTransitionWrapper = ({children}) => {
    const location = useLocation(); // Get the current location of the route

    // Define animations for the home page and other pages
    const isHomePage = location.pathname === '/' || location.pathname.match(/^\/courses\/\d+$/) || location.pathname.match(/^\/services\/\d+$/);

    return (
        <motion.div
            key={location.pathname}  // Ensure that the component re-renders on route change
            initial={{
                opacity: 0,
                y: isHomePage ? 0 : 30,  // For home page, start from opacity 0 and y position 0, for others start from y position 30
            }}
            animate={{
                opacity: 1,
                y: 0,  // The final state for both
            }}
            exit={{
                opacity: 0,
                y: -30,  // Exit animation moves the page upwards when transitioning out
            }}
            transition={{
                duration: isHomePage ? 1 : 0.5,  // Apply a longer transition for home page (fade-in), and shorter for others
                ease: "easeInOut",  // Easing for smooth transition
            }}
            className="page-transition-wrapper" // Add custom class for CSS if necessary
        >
            {children}
        </motion.div>
    );
};

export default PageTransitionWrapper;
